import React, { useState, useEffect, useRef } from 'react';
import tea from '../../../assets/TeaAndSnacks/tea1.png';

import tea_disabled from '../../../assets/TeaAndSnacks/tea_disable.png';
import snacks from '../../../assets/TeaAndSnacks/snack.png';
import snacks_disabled from '../../../assets/TeaAndSnacks/snack_disable.png';
import healthy from '../../../assets/TeaAndSnacks/healthy.png';
import healthy_disabled from '../../../assets/TeaAndSnacks/healthy_disable.png';
import scanned from '../../../assets/TeaAndSnacks/scanned.png';
import successgif from '../../../assets/TeaAndSnacks/foodpanda-food.gif';
import canteen from '../../../assets/TeaAndSnacks/Coffee-shop.gif';
import RandR from '../../../assets/TeaAndSnacks/G.NXT_Delight.jpg';
import QRCode from 'react-qr-code';
import { encryptData } from '../../../utils/crypto';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../Auth/authSlice';
import foodImage from '../../../assets/TeaAndSnacks/food.png';
import PublicIcon from '@mui/icons-material/Public';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import {
  useAddReviewMutation,
  useGetAttendanceQuery,
  useGetConfigQuery,
  useGetRegionByEmpIdQuery,
  useGetRegionSnacksQuery,
  useGetReviewByEmpIdQuery,
  useGetScannedDataByEmpIdQuery,
  useGetSnacksQuery,
  useGetVoteQuery,
} from '../teaAndSnacksApiSlice';
import useInitializeSocket from '../../../hooks/sockets/useInitializeSocket';
import {
  Box,
  Typography,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  Backdrop,
  Card,
  CardContent,
  useMediaQuery,
  useTheme,
  Rating,
  Button,
  DialogTitle,
  Grid,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { Cancel, Feedback, Outbound, Close, Public } from '@mui/icons-material';
import { selectAttendance, setAttendance } from '../teaAndSnacksSlice';
import { set } from 'lodash';
import toast from 'react-hot-toast';
import { common } from '@mui/material/colors';
import { UserOptionCard } from './UserOptionCard';
import { fontSize } from '@mui/system';
import { margin } from '@mui/system';
import { textAlign } from '@mui/system';
import { padding } from '@mui/system';
import { width } from '@mui/system';

const UserPageNew = ({ event }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [qrData, setQrData] = useState(null);
  //   // 0 ==> not scanned/disabled, 1 ==> available/clickable, 2 ==> already scanned/scanned
  const [productStatus, setProductStatus] = useState(null);
  const [todaysSnack, setTodaysSnack] = useState(null);
  const [todaysHealthy, setTodaysHealthy] = useState(null);
  const [dialogContent, setDialogContent] = useState('');
  const user = useSelector(selectCurrentUser);
  const [configData, setConfigData] = useState(null);
  const containerRef = useRef(null);
  const [isFromButton, setFromButton] = useState(false);
  const [averageRating, setAverageRating] = useState(0);
  const [addReview] = useAddReviewMutation();
  const [qrSCanned, setQrSCanned] = useState('');

  const [isSame, setIsSame] = useState(false);
  const [locationName, setLocationName] = useState(
    user?.details?.travelData?.userDetails?.locationName ||
      (user?.region?.toLowerCase().includes('ch') ? 'Ahmedabad' : user?.region || 'Ahmedabad')
  );

  const [selectedLocation, setSelectedLocation] = useState(
    user?.details?.travelData?.userDetails?.locationName || user.region
  );
  const [regionSnacksData, setRegionSnacksData] = useState(null);
  const [snacksVoteData, setSnacksVoteData] = useState(null);
  const [locationChangePopup, setLocationChangePopup] = useState(false);
  const locations = ['Ahmedabad', 'Rajkot', 'Vadodara', 'Pune', 'Gandhinagar'];
  const [isAlreadyScanned, setAlreadyScanned] = useState(false);
  const [userScannedData, setUserScannedData] = useState({
    morningTea: 0,
    eveningTea: 0,
    snack: 0,
    healthy: 0,
  });
  const [productForReview, setProductForReview] = useState(null);
  const [userReviewData, setUserReviewData] = useState({
    morningTea: 0,
    eveningTea: 0,
    snack: 0,
    healthy: 0,
    commonComment: '',
  });
  const [userAlreadyReviewData, setUserAlreadyReviewData] = useState({
    morningTea: 0,
    eveningTea: 0,
    snack: 0,
    healthy: 0,
    commonComment: '',
  });
  const [popupRating, setPopupRating] = useState(0);
  const [popupComment, setPopupComment] = useState({});
  const {
    data: configApidata,
    isLoading: configLoading,
    isError: configError,
  } = useGetConfigQuery({ region: locationName });
  const {
    data: scannedDataOfUser,
    isLoading: scannedDataOfUserLoading,
    isError: scannedDataOfUserError,
    refetch: scannedDataOfUserRefetch,
  } = useGetScannedDataByEmpIdQuery({ empId: user.empId, region: locationName });

  const {
    data: reviewDataOfUser,
    isLoading: reviewDataOfUserLoading,
    isError: reviewDataOfUserError,
    refetch: reviewDataOfUserRefetch,
  } = useGetReviewByEmpIdQuery({ empId: user.empId, date: new Date(new Date().toDateString()).getTime() });

  const currentDate = new Date(new Date().toDateString()).getTime();
  const {
    data: regionSnacks,
    isLoading: regionSnacksLoading,
    isError: regionSnacksError,
    refetch: regionSnacksDataRefetch,
  } = useGetRegionSnacksQuery({ date: currentDate, region: locationName });
  const {
    data: snacksVote,
    isLoading: snacksVoteLoading,
    isError: snacksVoteError,
    refetch: snacksVoteDataRefetch,
  } = useGetVoteQuery({ date: currentDate, region: locationName, empId: user.empId }, { skip: !locationName });

  const {
    data: snacksData,
    isLoading: snacksLoading,
    isError: snacksError,
    refetch: snacksDataRefetch,
  } = useGetSnacksQuery();

  const {
    data: regionScannedData,
    isLoading: regionScannedDataLoading,
    isError: regionScannedDataError,
    refetch: regionScannedDataRefetch,
  } = useGetRegionByEmpIdQuery({ empId: user.empId });

  const socket = useInitializeSocket();
  const alreadyAttended = true;
  const {
    data: attendanceData,
    isLoading: attendanceDataLoading,
    isError: attendanceDataError,
  } = useGetAttendanceQuery({date:new Date(new Date().toDateString()).getTime()});
  const [isAttended, setIsAttended] = useState(false);
  // const isAttended = attendanceData?.filter((item) => item.empId == user.empId).length > 0
  const productForReviewRef = useRef(productForReview);
  const userReviewDataRef = useRef(userReviewData);  

  useEffect(() => {
    if (attendanceData && Array.isArray(attendanceData)) {
      if (attendanceData.filter((item) => item.empId == user.empId).length > 0) {
        setIsAttended(true);
      }
    }
  }, [attendanceData]);

  useEffect(() => {
    productForReviewRef.current = productForReview;
  }, [productForReview]);

  useEffect(() => {
    userReviewDataRef.current = userReviewData;
  }, [userReviewData]);

  socket.on('processing', (response) => {
    setIsLoading(response.loading);
    setQrData(null);
  });

  socket.on('complete', (response) => {
    setSelectedProduct(null);
    scannedDataOfUserRefetch();
    setIsLoading(response.loading);
    setAlreadyScanned(true);
    const currentProduct = productForReviewRef.current;
    const currentReviewData = userReviewDataRef.current;

    const reviewKey =
      currentProduct === 'Morning'
        ? 'morningTea'
        : currentProduct === 'Evening'
        ? 'eveningTea'
        : currentProduct === 'Snack'
        ? 'snack'
        : currentProduct === 'Healthy'
        ? 'healthy'
        : null;

    const alreadyReviewed = reviewKey && currentReviewData?.[reviewKey] > 0;

    if (alreadyReviewed) {
      setQrSCanned('!');
    } else {
      setDialogContent('!');
    }
  });

  socket.on('attendanceProcessing', (response) => {
    setIsLoading(response.loading);
    setQrData(null);
  });

  socket.on('attendanceComplete', (response) => {
    setIsLoading(response.loading);
    setIsAttended(true);
  });

  socket.on('snacks-added', (data) => {
    if (snacksData) {
      snacksDataRefetch();
    }
  });

  socket.on('region-snacks-added', (data) => {
    if (data.region == locationName) {
      setRegionSnacksData({ snack: data.snack });
      if (regionSnacksData && snacksVoteData) {
        regionSnacksDataRefetch();
        snacksVoteDataRefetch();
      }
    }
  });

  useEffect(() => {
    if (snacksVote) {
      snacksVoteDataRefetch();
    }
  }, [snacksVote]);

  const getConfigTime = () => {
    if (!configLoading && !configError && configApidata) {
      const data = configApidata;
      return {
        morningEndTime: {
          hours: parseInt(data?.morningEndTime.split(':')[0]),
          minutes: parseInt(data?.morningEndTime.split(':')[1]),
        },
        eveningStartTime: {
          hours: parseInt(data?.eveningStartTime.split(':')[0]),
          minutes: parseInt(data?.eveningStartTime.split(':')[1]),
        },

        voteEndTime: {
          hours: parseInt(data?.voteEndTime.split(':')[0]),
          minutes: parseInt(data?.voteEndTime.split(':')[1]),
        },
        maxMorning: data?.morningTea,
        maxEvening: data?.eveningTea,
        maxSnack: data?.snack,
      };
    }
  };

  // const handleProductClick = (product) => {
  //   // if (selectedProduct === product) return;
  //   console.log('socket....',socket,socket.id);
  //   if (socket.id !== null) {
  //     setSelectedProduct(product);
  //     containerRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  //     const dataForQr = {
  //       empId: user.empId,
  //       name: user.username,
  //       product,
  //       date: new Date(new Date().toDateString()).getTime(),
  //       socketId: socket.id,
  //       token: Math.floor(Math.random() * 1000000),
  //     };

  //     const encryptedData = encryptData(dataForQr);
  //     setQrData(encryptedData);
  //   }
  // };

  const handleProductClick = (product) => {
    if (!['admin', 'vendor', 'marcom', 'canteenAdmin', 'sports_social_celebration', 'learning_development'].includes(user.username)) {
      setSelectedProduct(product);
      setProductForReview(product);
      setFromButton(false);
      containerRef.current?.scrollTo({ top: 0, behavior: 'smooth' });

      const dataForQr = {
        empId: user.empId,
        name: user.username,
        product,
        date: new Date(new Date().toDateString()).getTime(),
        token: Math.floor(Math.random() * 1000000),
        staff: false,
        region: locationName,
      };

      const waitForSocketIdAndGenerateQR = () => {
        if (socket?.id) {
          const finalData = { ...dataForQr, socketId: socket.id };

          const encryptedData = encryptData(finalData);
          setQrData(encryptedData);
        } else {
          // Retry after a short delay
          setTimeout(waitForSocketIdAndGenerateQR, 200); // Retry every 200ms
        }
      };

      waitForSocketIdAndGenerateQR();
    }
  };

  useEffect(() => {
    if (!snacksLoading && !snacksError && snacksData?.length > 0) {
      setTodaysSnack(snacksData[0].snack);
      setTodaysHealthy(snacksData[0].healthy);
    }
  }, [snacksData, snacksLoading]);

  useEffect(() => {
    if (!regionScannedDataLoading && !regionScannedDataError && regionScannedData?.length > 0) {
      setLocationName(regionScannedData[0]);
      setAlreadyScanned(true);
    }
  }, [regionScannedData, regionScannedDataLoading]);

  // Fetch User's Scan Data
  useEffect(() => {
    let configTime = getConfigTime();
    setConfigData(configTime);
    const dateToday = new Date();
    let morningEndTime = new Date(dateToday);
    morningEndTime.setHours(configTime?.morningEndTime.hours);
    morningEndTime.setMinutes(configTime?.morningEndTime.minutes);
    let eveningStartTime = new Date(dateToday);
    eveningStartTime.setHours(configTime?.eveningStartTime.hours);
    eveningStartTime.setMinutes(configTime?.eveningStartTime.minutes);
    let scanData = null;
    if (!scannedDataOfUserLoading && !scannedDataOfUserError && scannedDataOfUser != null) {
      let data = scannedDataOfUser;
      scanData = {
        isMorning:
          dateToday <= morningEndTime
            ? data?.count?.morningTea >= configTime?.maxMorning
              ? 2
              : 1
            : data?.count?.morningTea >= configTime?.maxMorning
            ? 2
            : 0,
        isEvening:
          dateToday >= eveningStartTime
            ? data?.count?.eveningTea >= configTime?.maxEvening
              ? 2
              : 1
            : data?.count?.eveningTea >= configTime?.maxEvening
            ? 2
            : 0,
        isSnack:
          dateToday >= eveningStartTime
            ? data?.count?.snack + data?.count?.healthy >= configTime?.maxSnack
              ? 2
              : 1
            : data?.count?.snack + data?.count?.healthy >= configTime?.maxSnack
            ? 2
            : 0,
        isHealthy:
          dateToday >= eveningStartTime
            ? data?.count?.snack + data?.count?.healthy >= configTime?.maxSnack
              ? 2
              : 1
            : data?.count?.snack + data?.count?.healthy >= configTime?.maxSnack
            ? 2
            : 0,
      };
      setUserScannedData(scannedDataOfUser.count);
    } else {
      scanData = {
        isMorning: dateToday <= morningEndTime ? 1 : 0,
        isEvening: dateToday >= eveningStartTime ? 1 : 0,
        isSnack: dateToday >= eveningStartTime ? 1 : 0,
        isHealthy: dateToday >= eveningStartTime ? 1 : 0,
      };
    }
    setProductStatus(scanData);
  }, [scannedDataOfUser, scannedDataOfUserLoading, configApidata]);

  useEffect(() => {
    if (!reviewDataOfUserLoading && !reviewDataOfUserError && reviewDataOfUser) {
      setAverageRating(reviewDataOfUser?.data?.average);
      setUserReviewData({
        morningTea: reviewDataOfUser?.data?.rating?.morningTea || 0,
        eveningTea: reviewDataOfUser?.data?.rating?.eveningTea || 0,
        snack: reviewDataOfUser?.data?.rating?.snack || 0,
        healthy: reviewDataOfUser?.data?.rating?.healthy || 0,
        commonComment: reviewDataOfUser?.data?.review?.common || '',
      });
      setUserAlreadyReviewData({
        morningTea: reviewDataOfUser?.data?.rating?.morningTea || 0,
        eveningTea: reviewDataOfUser?.data?.rating?.eveningTea || 0,
        snack: reviewDataOfUser?.data?.rating?.snack || 0,
        healthy: reviewDataOfUser?.data?.rating?.healthy || 0,
        commonComment: reviewDataOfUser?.data?.review?.common || '',
      });
      setIsLoading(false);
    } else if (reviewDataOfUserLoading) {
      setIsLoading(true);
    }
  }, [reviewDataOfUser, isFromButton]);

  useEffect(() => {
    if (!regionSnacksLoading && !regionSnacksError && regionSnacks) {
      setRegionSnacksData(regionSnacks.data);
      setIsLoading(false);
    } else if (regionSnacksLoading) {
      setIsLoading(true);
    }
  }, [regionSnacks, regionSnacksLoading]);

  useEffect(() => {
    if (!snacksVoteLoading && !snacksVoteError && snacksVote) {
      if (snacksVote?.data) {
        setSnacksVoteData(snacksVote.data);
      } else {
        setSnacksVoteData(null);
      }
      setIsLoading(false);
      if (snacksVote?.data?.vote) {
        setLocationName(snacksVote.data.region);
      }
    } else if (snacksVoteLoading) {
      setIsLoading(true);
    }
  }, [snacksVote, snacksVoteLoading, regionSnacks]);

  const waitForSocketIdAndGenerateQR = () => {
    if (socket?.id) {
      if (event && user) {
        const qrForEvent = `gatewayEvent2025|${user.username}|${user.empId}|${socket.id}`;
        console.log(qrForEvent);
        setQrData(qrForEvent);
      }
    } else {
      // Retry after a short delay
      setTimeout(waitForSocketIdAndGenerateQR, 200); // Retry every 200ms
    }
  };
  useEffect(() => {
    if (event && user) {
      const qrForEvent = `gatewayEvent2025|${user.username}|${user.empId}`
      console.log(qrForEvent);
      setQrData(qrForEvent);
    }
    waitForSocketIdAndGenerateQR();
  }, [event, user]);

  // Reset component state when switching tabs
  useEffect(() => {
    if (!event) {
      // Only reset these when switching to tea & snacks tab
      setSelectedProduct(null);
      setQrData(null);
    }
    setDialogContent('');
    setQrSCanned('');
  }, [event]);

  const handleCloseDialog = () => {
    setDialogContent('');
    setFromButton(false);
    setQrData(null);
    setRatings([]);
    setSelectedProduct(null);
    setUserReviewData({
      morningTea: 0,
      eveningTea: 0,
      snack: 0,
      healthy: 0,
      commonComment: '',
    });
    setUserAlreadyReviewData({
      morningTea: 0,
      eveningTea: 0,
      snack: 0,
      healthy: 0,
      commonComment: '',
    });
  };

  const [ratings, setRatings] = useState([{ product: productForReview, rate: 0 }]);

  let [isApiCalling, setApiCalling] = useState(false);

  const handleReview = async () => {
    let dataForReview = {};
    if (!isFromButton) {
      dataForReview = {
        empId: user.empId,
        name: user.username,
        ratings: ratings,
        reviews: popupComment,
        date: new Date(new Date().toDateString()).getTime(),
        region: locationName,
      };
    } else {
      const newRatings = [];

      Object.keys(userReviewData).forEach((key) => {
        if (key === 'morningTea') {
          newRatings.push({ product: 'Morning', rate: userReviewData[key] });
        } else if (key === 'eveningTea') {
          newRatings.push({ product: 'Evening', rate: userReviewData[key] });
        } else if (key === 'snack') {
          newRatings.push({ product: 'Snack', rate: userReviewData[key] });
        } else if (key === 'healthy') {
          newRatings.push({ product: 'Healthy', rate: userReviewData[key] });
        }
      });

      // Now update state just once
      setRatings(newRatings);
      dataForReview = {
        empId: user.empId,
        name: user.username,
        ratings: newRatings,
        reviews: { product: 'common', comment: userReviewData.commonComment },
        date: new Date(new Date().toDateString()).getTime(),
        region: locationName,
      };
    }

    try {
      const response = await addReview(dataForReview).unwrap();

      if (response.data !== null) {
        setApiCalling(true);
        toast.success('Review Added');
        reviewDataOfUserRefetch();
      }
    } catch (e) {
      console.log(e);
      toast.error('Something went wrong');
    } finally {
      setApiCalling(false);
      handleCloseDialog();
    }
  };

  const handleRateChange = (rate) => {
    setRatings([{ product: productForReview, rate }]);
  };

  const text = { Morning: 'morningTea', Evening: 'eveningTea', Snack: 'snack', Healthy: 'healthy' };

  // Check if any rating is given in 'isFromButton' mode
  const isAnyRatingGiven = isFromButton
    ? ['morningTea', 'eveningTea', 'snack', 'healthy'].some((key) => {
        const isScanned = userScannedData[key] !== 0;
        const rating = userReviewData[key];
        return isScanned && rating > 0;
      })
    : ratings.length > 0 && parseInt(ratings[0].rate) > 0;

  useEffect(() => {
    let isSame =
      JSON.stringify(userAlreadyReviewData) === JSON.stringify(userReviewData) && ratings[0]?.product == null;
    setIsSame(isSame);
  }, [userAlreadyReviewData, userReviewData, ratings]);

  const isSubmitEnabled = isAnyRatingGiven;

  const isSubmitReview = !['Morning', 'Evening', 'Snack', 'Healthy'].every(
    (label) => userAlreadyReviewData[text[label]]
  );

  let selectedLabel = '';
  if (productForReview == 'Morning') {
    selectedLabel = 'Morning Tea';
  } else if (productForReview == 'Evening') {
    selectedLabel = 'Evening Tea';
  } else if (productForReview == 'Snack') {
    selectedLabel = 'Evening Snack';
  } else if (productForReview == 'Healthy') {
    selectedLabel = 'Evening Healthy Snack';
  }

  return (
    <Box
      ref={containerRef}
      sx={{
        textAlign: 'center',
        p: 1,
        bgcolor: 'white',
        // height: 'calc(100vh - 185px)',
        height: '100%',
        // overflow: 'scroll',
      }}
    >
      { !isAlreadyScanned && !event && (
        <Box style={{ display: 'flex', justifyContent: 'space-between', margin: 1, alignItems: 'center' }}>
          <Typography sx={{ color: '#0A4FAC', fontSize: "80%" }}>
            Click the location icon to update your location.
          </Typography>

          <LocationOnIcon
            sx={{ color: '#0A4FAC', cursor: 'pointer', fontSize: 30 }}
            onClick={() => {
              setLocationChangePopup(true);
            }}
          />
        </Box>
      )}
      {/* <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#0A4FAC', mb: 2 }}>
        Choose Your Refreshment
      </Typography> */}

      {
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            p: 1,
            bgcolor: '#fff',
            flexDirection: 'column',
            // bgcolor: 'red',
            borderRadius: 3,
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
            maxWidth: event ? '100%' : '80%',
            mx: 'auto',
            height: '50%',
          }}
        >
          {console.log('isAttended', isAttended)}
          {event ? (
            isAttended ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 3 }}>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 600,
                    color: '#0A4FAC',
                    textAlign: 'center',
                    fontSize: '1.3rem',
                  }}
                >
                  🎉 Thank you for attending the Event!
                </Typography>
              
              </Box>
            ) : (
              qrData && <QRCode value={qrData} size={200} />
            )
          ) : qrData && selectedProduct && productStatus && productStatus[`is${selectedProduct}`] === 1 ? (
            <QRCode value={qrData} size={200} />
          ) : (
            // <img src={canteen} width={'content-fit'} height={'90%'} />
            <img src={RandR} width={'content-fit'} height={'90%'} />

          )}
          {((scannedDataOfUser)&& !event) && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
              <Button
                style={{
                  backgroundColor: 'white',
                  color: '#0A4FAC',
                  fontSize: '10px',
                  height: '20px',
                  border: '1px solid #0A4FAC',
                }}
                onClick={() => {
                  setDialogContent('writeReview');
                  setUserAlreadyReviewData({
                    morningTea: 0,
                    eveningTea: 0,
                    snack: 0,
                    healthy: 0,
                    commonComment: '',
                  });
                  setFromButton(true);
                }}
              >
                write review
              </Button>

              <Rating precision={0.25} size="medium" defaultValue={averageRating} value={averageRating} readOnly />
            </Box>
          )}
        </Box>

      
      }
     {event && <Box
        sx={{
           display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            px: 3,
            py: 2.5,
            background: 'linear-gradient(135deg, #0A4FAC 0%, #1E6FD9 100%)',
            flexDirection: 'column',
            borderRadius: 3,
            boxShadow: '0px 6px 16px rgba(10, 79, 172, 0.25)',
            maxWidth: '100%',
            mx: 'auto',
            mt: 2.5,
            mb: 2,
            gap: 0.5,
        }}
      >
        <Typography
          sx={{
            color: 'rgba(255,255,255,0.8)',
            fontSize: '0.7rem',
            fontWeight: 600,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
          }}
        >
          Festive Celebration
        </Typography>
        <Typography
          variant="h5"
          sx={{
            color: '#fff',
            textAlign: 'center',
            fontSize: '1.5rem',
            fontWeight: 700,
            lineHeight: 1.3,
          }}
        >
          {/* Gateway Housie Game */}
          Diwali Lunch
        </Typography>
        <Typography
          sx={{
            color: 'rgba(255,255,255,0.9)',
            fontSize: '0.8rem',
            textAlign: 'center',
          }}
        >
          Celebrate the festival of lights together
        </Typography>
        {/* <Button
          variant="contained"
          href="https://anvact.vaanilabs.ai/play"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            backgroundColor: '#0A4FAC',
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.2,
            borderRadius: 2,
            fontSize: '0.95rem',
            '&:hover': {
              backgroundColor: '#083b82',
            },
          }}
        >
          Explore Now
        </Button> */}
      </Box>}
      {locationName == 'Ahmedabad' ? (
        !event && (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 1, height: '42%', mt: 3 }}>
            {['Morning', 'Evening', 'Snack', 'Healthy'].map((product, index) => (
              <ProductCard
                key={index}
                product={product}
                selectedProduct={selectedProduct}
                onClick={handleProductClick}
                status={productStatus ? productStatus[`is${product}`] : 0}
                todaysSnack={todaysSnack}
                todaysHealthy={todaysHealthy}
                userScannedData={userScannedData}
                dialogContent={dialogContent}
                setDialogContent={setDialogContent}
                cardStyle={!snacksVoteData && snacksVoteData == undefined && !isAlreadyScanned && {height:"45%"}}
              />
            ))}
          </Box>
        )
      ) : !snacksVoteData &&!event ? (
        <Box>
          <Box style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 5, height: '40%', mt: 3 }}>
            {['Morning'].map((product, index) => (
              <ProductCard
                key={index}
                product={product}
                selectedProduct={selectedProduct}
                onClick={handleProductClick}
                status={productStatus ? productStatus[`is${product}`] : 0}
                todaysSnack={regionSnacksData?.snack}
                todaysHealthy={todaysHealthy}
                userScannedData={userScannedData}
                dialogContent={dialogContent}
                setDialogContent={setDialogContent}
                isOtherRegion={true}
                imageStyle={{ height: '10%', width: '12%', objectFit: 'contain' }}
                cardStyle={{ height: '10%', width: '80%', marginTop: '3%', padding: 0 }}
                CardContentStyle={
                  !snacksVoteData && {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 0,
                    '&:last-child': {
                      pb: 1, // or your preferred value (theme.spacing(2) = 16px)
                    },
                  }
                }
                // snacksStyle={{ height: '50%', width: '100%', marginTop: '12px' }}
                snacksLabelStyle={{ fontSize: '18px', mt: 1, ml: 1 }}
                scannedImgStyle={{ top: -18,width:80 }}
              />
            ))}
          </Box>
          <UserOptionCard
            snacksData={regionSnacksData}
            setSnacksVoteData={setSnacksVoteData}
            configData={getConfigTime()}
            locationName={locationName}
            setIsLoading={setIsLoading}
          />
        </Box>
      ) : snacksVoteData?.vote && !event  ? (
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: 1,
            alignItems: 'center',
            margin: '25px',
          }}
        >
          {['Morning', 'Evening', 'Snack']?.map((product, index) => (
            <ProductCard
              key={index}
              product={product}
              selectedProduct={selectedProduct}
              onClick={handleProductClick}
              status={productStatus ? productStatus[`is${product}`] : 0}
              todaysSnack={regionSnacksData?.snack}
              todaysHealthy={todaysHealthy}
              userScannedData={userScannedData}
              dialogContent={dialogContent}
              setDialogContent={setDialogContent}
              isOtherRegion={true}
              // imageStyle={{ height: '35%', width: '35%', objectFit: 'contain' }}
              // cardStyle={{ height: '100%', width: '80%', marginTop: '12px' }}
              // snacksLabelStyle={{ fontSize: '17px' }}
            />
          ))}
        </Box>
      ) : (
        snacksVoteData?.length != 0&&!event && (
          <Box sx={{ height: '50%' }}>
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: 1,
                alignItems: 'center',
                margin: '25px',
              }}
            >
              {['Morning', 'Evening'].map((product, index) => (
                <ProductCard
                  key={index}
                  product={product}
                  selectedProduct={selectedProduct}
                  onClick={handleProductClick}
                  status={productStatus ? productStatus[`is${product}`] : 0}
                  todaysSnack={regionSnacksData?.snack}
                  todaysHealthy={todaysHealthy}
                  userScannedData={userScannedData}
                  dialogContent={dialogContent}
                  setDialogContent={setDialogContent}
                  isOtherRegion={true}
                  // imageStyle={{ height: '35%', width: '35%', objectFit: 'contain' }}
                  // cardStyle={{ height: '100%', width: '80%', marginTop: '12px' }}
                  // snacksLabelStyle={{ fontSize: '17px' }}
                />
              ))}
            </Box>
            <Typography style={{ color: '#0A4FAC', fontWeight: 'bold', fontSize: '16px', margin: '25px' }}>
              Thank you for your vote. Since you selected 'No' for today's snacks, you will not be able to take the
              snacks.
            </Typography>
          </Box>
        )
      )}

      <Backdrop open={isLoading}   sx={{ backgroundColor: "rgba(255,255,255,0.4)" }}>
        <CircularProgress sx={{color:"#0A4FAC" }}  />
      </Backdrop>

      <Dialog
        open={Boolean(dialogContent)}
        onClose={() => {
          handleCloseDialog();
        }}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: 10,
            position: 'relative',
          },
        }}
      >
        {/* Floating Close Button */}
        <IconButton
          onClick={() => {
            handleCloseDialog();
          }}
          sx={{
            position: 'absolute',
            right: 12,
            top: 12,
            backgroundColor: '#F3F6F9',
            borderRadius: '50%',
            padding: '6px',
            color: '#0A4FAC',
            zIndex: 1,
            '&:hover': {
              backgroundColor: '#e0e7ff',
            },
          }}
        >
          <Cancel fontSize="small" />
        </IconButton>

        {/* Title */}
        <DialogTitle
          sx={{
            m: 0,
            pt: 4,
            pb: 2,
            textAlign: 'center',
            color: '#0A4FAC',
            fontWeight: 'bold',
            fontSize: '1.4rem',
          }}
        >
          We appreciate your feedback.
        </DialogTitle>

        {/* Content */}
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            pt: 1,
            pb: 4,
            // px: 4,
          }}
        >
          {/* Ratings Section */}
          {isFromButton ? (
            <>
              <Typography
                variant="body1"
                sx={{
                  color: '#555',
                  textAlign: 'center',
                  fontSize: '0.8rem',
                  lineHeight: 1.6,
                  maxWidth: 500,
                }}
              >
                To enhance your experience, we’d love your feedback on today’s delights. Please rate the following:
              </Typography>

              {locationName == 'Ahmedabad' ? (
                <Box sx={{ width: '100%', maxWidth: 400 }}>
                  {['Morning', 'Evening', 'Snack', 'Healthy'].map((label, index) => {
                    const value = userReviewData[text[label]];
                    const isReadOnly = userAlreadyReviewData[text[label]];

                    return (
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                          backgroundColor: index % 2 === 0 ? '#f9fafc' : 'transparent',
                          px: 2,
                          py: 1.5,
                          borderRadius: 2,
                        }}
                        key={label}
                      >
                        <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
                          {label}
                        </Typography>
                        <Rating
                          name={`${label}-rating`}
                          onChange={(e, newValue) => {
                            setUserReviewData({
                              ...userReviewData,
                              [text[label]]: newValue ?? 0, // fallback to 0 if user clears the rating
                            });
                          }}
                          precision={1}
                          size="medium"
                          value={value || 0}
                          readOnly={isReadOnly}
                          disabled={userScannedData[text[label]] === 0}
                        />
                      </Grid>
                    );
                  })}
                  <TextField
                    multiline
                    rows={2}
                    value={userReviewData.commonComment}
                    inputProps={{
                      maxLength: 150, // <-- Character limit
                    }}
                    onChange={(e) => {
                      setUserReviewData({ ...userReviewData, commonComment: e.target.value });
                    }}
                    variant="outlined"
                    disabled={
                      !Object.values(userScannedData).some((val) => val > 0) || // if no item was scanned
                      ['Morning', 'Evening', 'Snack', 'Healthy'].every((label) => userAlreadyReviewData[text[label]]) // all reviewed
                    }
                    placeholder="What can we do to improve your experience?"
                    fullWidth
                    InputProps={{
                      sx: {
                        '&::placeholder': {
                          fontSize: '0.8rem', // For native placeholder
                        },
                        '& input::placeholder': {
                          fontSize: '0.8rem',
                        },
                        '& textarea::placeholder': {
                          fontSize: '0.8rem',
                        },
                      },
                    }}
                  />
                </Box>
              ) : (
                <Box sx={{ width: '100%', maxWidth: 400 }}>
                  {(snacksVoteData ? ['Snack', 'Morning', 'Evening'] : ['Morning', 'Evening']).map((label, index) => {
                    const value = userReviewData[text[label]];
                    const isReadOnly = userAlreadyReviewData[text[label]];

                    return (
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                          backgroundColor: index % 2 === 0 ? '#f9fafc' : 'transparent',
                          px: 2,
                          py: 1.5,
                          borderRadius: 2,
                        }}
                        key={label}
                      >
                        <Typography variant="body2" sx={{ color: '#333', fontWeight: 500 }}>
                          {label}
                        </Typography>
                        <Rating
                          name={`${label}-rating`}
                          onChange={(e, newValue) => {
                            setUserReviewData({
                              ...userReviewData,
                              [text[label]]: newValue ?? 0, // fallback to 0 if user clears the rating
                            });
                          }}
                          precision={1}
                          size="medium"
                          value={value || 0}
                          readOnly={isReadOnly}
                          disabled={userScannedData[text[label]] === 0}
                        />
                      </Grid>
                    );
                  })}
                  <TextField
                    multiline
                    rows={2}
                    value={userReviewData.commonComment}
                    inputProps={{
                      maxLength: 150, // <-- Character limit
                    }}
                    onChange={(e) => {
                      setUserReviewData({ ...userReviewData, commonComment: e.target.value });
                    }}
                    variant="outlined"
                    disabled={
                      !Object.values(userScannedData).some((val) => val > 0) || // if no item was scanned
                      ['Morning', 'Evening', 'Snack', 'Healthy'].every((label) => userAlreadyReviewData[text[label]]) // all reviewed
                    }
                    placeholder="What can we do to improve your experience?"
                    fullWidth
                    InputProps={{
                      sx: {
                        '&::placeholder': {
                          fontSize: '0.8rem', // For native placeholder
                        },
                        '& input::placeholder': {
                          fontSize: '0.8rem',
                        },
                        '& textarea::placeholder': {
                          fontSize: '0.8rem',
                        },
                      },
                    }}
                  />
                </Box>
              )}
            </>
          ) : (
            <>
              <Typography
                variant="body1"
                sx={{
                  color: '#555',
                  textAlign: 'center',
                  fontSize: '0.8rem',
                  lineHeight: 1.6,
                  maxWidth: 500,
                }}
              >
                We’re always looking to improve your experience. Please take a moment to rate your experience with
                today’s <span style={{ fontWeight: 'bold' }}>{selectedLabel}</span>.
              </Typography>

              <Rating
                onChange={(e, newValue) => {
                  handleRateChange(newValue ?? 0); // if newValue is null, reset to 0
                }}
                value={ratings[0]?.rate ?? 0}
                name="experience-rating"
                precision={1}
                size="large"
                sx={{ mt: 2 }}
              />

              <TextField
                multiline
                rows={2}
                onChange={(e) => {
                  setPopupComment({ product: productForReview, comment: e.target.value });
                }}
                inputProps={{
                  maxLength: 150, // <-- Character limit
                }}
                variant="outlined"
                placeholder="Write your feedback here..."
                fullWidth
                InputProps={{
                  sx: {
                    '&::placeholder': {
                      fontSize: '0.8rem', // For native placeholder
                    },
                    '& input::placeholder': {
                      fontSize: '0.8rem',
                    },
                    '& textarea::placeholder': {
                      fontSize: '0.8rem',
                    },
                  },
                }}
              />
            </>
          )}

          {/* Submit */}
          {isSubmitReview ? (
            <Button
              variant="contained"
              size="large"
              sx={{
                backgroundColor: '#0A4FAC',
                mt: 1,
                textTransform: 'none',
                fontWeight: 500,
                px: 4,
                py: 1,
                borderRadius: 2,
                '&:hover': {
                  backgroundColor: '#083b82',
                },
              }}
              disabled={isSame || !isSubmitEnabled || !isSubmitReview || isApiCalling}
              onClick={() => {
                setDialogContent('');
                handleReview();
              }}
            >
              Submit Feedback
            </Button>
          ) : (
            <Typography
              variant="h1"
              sx={{ color: '#0A4FAC', textAlign: 'center', fontSize: '0.8rem', lineHeight: 1.6 }}
            >
              Thank you for your feedback !!
            </Typography>
          )}
        </DialogContent>
      </Dialog>

      <Dialog open={Boolean(qrSCanned)} onClose={() => setQrSCanned('')}>
        <IconButton sx={{ position: 'absolute', top: 10, right: 10 }} onClick={() => setQrSCanned('')}>
          <Close />
        </IconButton>
        <DialogContent>
          <img src={successgif} width={'100%'} alt="Success" />
        </DialogContent>
      </Dialog>

      <Dialog open={locationChangePopup} onClose={() => setQrSCanned('')}>
        <IconButton
          sx={{ position: 'absolute', top: 10, right: 10 }}
          onClick={() => {
            setSelectedLocation(user?.details?.travelData?.userDetails?.locationName || user.region);
            setLocationChangePopup(false);
          }}
        >
          <Close />
        </IconButton>
        {/* Title */}
        <DialogTitle
          sx={{
            m: 0,
            pt: 4,
            pb: 2,
            textAlign: 'center',
            color: '#0A4FAC',
            fontWeight: 'bold',
            fontSize: '1.4rem',
          }}
        >
          Select Location
        </DialogTitle>

        {/* Content */}
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            pt: 1,
            pb: 4,
            // px: 4,
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography style={{ color: 'grey', fontSize: '14px', margin: '15px' }}>
              Kindly choose your location from the list below.
            </Typography>
            <FormControl fullWidth>
              <InputLabel id="location-label">Location</InputLabel>
              <Select
                labelId="location-label"
                id="location-select"
                value={selectedLocation}
                label="Location"
                onChange={(e) => {
                  setSelectedLocation(e.target.value);
                }}
              >
                {locations.map((loc, index) => (
                  <MenuItem key={index} value={loc}>
                    {loc}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          {/* Submit */}
          <Button
            variant="contained"
            size="large"
            sx={{
              backgroundColor: '#0A4FAC',
              mt: 1,
              textTransform: 'none',
              fontWeight: 500,
              px: 4,
              py: 1,
              borderRadius: 2,
              '&:hover': {
                backgroundColor: '#083b82',
              },
            }}
            onClick={() => {
              setLocationName(selectedLocation);
              setLocationChangePopup(false);
            }}
          >
            Done
          </Button>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

const ProductCard = ({
  product,
  selectedProduct,
  onClick,
  status,
  todaysSnack,
  todaysHealthy,
  userScannedData,
  dialogContent,
  setDialogContent,
  imageStyle,
  cardStyle,
  snacksLabelStyle,
  isOtherRegion,
  CardContentStyle,
  scannedImgStyle,
}) => {
  const icons = {
    Morning: {
      0: tea_disabled,
      1: tea,
      2: tea_disabled,
    },
    Evening: {
      0: tea_disabled,
      1: tea,
      2: tea_disabled,
    },
    Snack: {
      0: snacks_disabled,
      1: snacks,
      2: snacks_disabled,
    },
    Healthy: {
      0: healthy_disabled,
      1: healthy,
      2: healthy_disabled,
    },
  };
  const text = { Morning: 'morningTea', Evening: 'eveningTea', Snack: 'snack', Healthy: 'healthy' };
  const value = userScannedData[text[product]];
  const theme = useTheme();
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  return (
    <Card
      onClick={status === 1 ? () => onClick(product) : null}
      sx={{
        width: '40%',
        height: '50%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 3,
        border: '2px solid ',
        borderColor: selectedProduct === product ? '#0A4FAC' : '#ccc',
        bgcolor: selectedProduct === product ? '#D1E8FF' : '#fff',
        cursor: status === 1 ? 'pointer' : 'not-allowed',
        opacity: status === 1 ? 1 : 0.6,
        position: 'relative',
        transition: 'all 0.3s ease-in-out',

        boxShadow: selectedProduct === product ? '0px 4px 10px rgba(0,0,0,0.3)' : 'none',
        '&:hover': {
          boxShadow: '0px 4px 10px rgba(0,0,0,0.2)',
          transform: 'scale(1.05)',
        },
        ...cardStyle,
      }}
    >
      {status === 2 && (
        <img src={scanned} alt="Scanned" style={{ position: 'absolute', top: 15, width: 100, ...scannedImgStyle }} />
      )}
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          justifyContent: 'center',          
          ...CardContentStyle,
        }}
      >
        <img
          src={icons[product][status]}
          alt={product}
          style={{
            width: isSm
              ? product === 'Healthy' || product === 'Snack'
                ? todaysSnack?.length > 20 || todaysHealthy?.length > 20
                  ? '30%'
                  : '45%'
                : '55%'
              : 40,
            height: isSm
              ? product === 'Healthy' || product === 'Snack'
                ? todaysSnack?.length > 20 || todaysHealthy?.length > 20
                  ? '30%'
                  : '45%'
                : '45%'
              : 40,
            ...imageStyle,
          }}
        />
        <Typography
          sx={{
            fontWeight: 'bold',
            color: '#0A4FAC',
            fontSize:
              (product === 'Healthy' || product === 'Snack') && (todaysSnack?.length > 20 || todaysHealthy?.length > 20)
                ? 12
                : 14,
            ...snacksLabelStyle,
          }}
        >
          {product}
          {(product === 'Healthy' || product === 'Snack') && !isOtherRegion && ` (${value})`}
        </Typography>
        {product === 'Snack' && (
          <Typography sx={{ fontSize: 12, color: '#5d4037', wordBreak: 'break-word', ...snacksLabelStyle }}>
            {/* {todaysSnack?.length > 20 ? `${(todaysSnack)?.slice(0, 20)}...` : todaysSnack || ''}
             */}
            {todaysSnack?.length > 20 ? `${todaysSnack?.slice(0, 20)}...` : todaysSnack || ''}
          </Typography>
        )}
        {product === 'Healthy' && (
          <Typography sx={{ fontSize: 12, color: '#5d4037', wordBreak: 'break-word' }}>
            {todaysHealthy?.length > 20 ? `${todaysHealthy?.slice(0, 20)}...` : todaysHealthy || ''}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default UserPageNew;
